<template>
    <div class="email__list_table">
        <component-table
            :labels="[
                {
                    key: 'category',
                    title: 'Category',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'title',
                    title: 'Title',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'trigger',
                    title: 'Trigger',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'subject',
                    title: 'Subject',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'recipient',
                    title: 'Recipient',
                    type: 'array',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'active',
                    title: 'Status',
                    type: 'boolean',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'actions',
                    title: '',
                    type: '',
                    sortable: false
                }
            ]"
            :items="items"
            :component-table-item="EmailsListTableItem"
            @emit-open-pop="openNotificationEmail"
            @emit-delete="openNotifyDeleteEmail"
            @emit-sort="handleSort"
            @emit-update-status="openNotifyUpdateEmailStatus"
        />
        <pop-side
            ref="popnotification"
            :title="''"
            :custom-button-disabled="!emailStatus"
            :primary-button-disabled="!emailStatus"
            :primary-button-animate-loading="true"
            :primary-button-animate-loading-name="'email-submit'"
            :secondary-button-active="false"
            :primary-button-text="'Save notification'"
            :primary-button-notify-active="true"
            :menu-button-active="Boolean(emailOwnerId) && !emailCloned"
            :menu-button-items="[
                {
                    key: 'restore',
                    name: 'Restore original content'
                }
            ]"
            @emit-close="clearEmail"
            @emit-primary="submitEmail"
            @emit-restore="openNotifyRestoreEmail"
        >
            <pop-side-email
                :disabled="!emailStatus"
                ref="popnotificationemail"
            />
        </pop-side>
        <pop-notify
            ref="notifyrestoreemail"
            :class="'pop__notify--restoreemail'"
            :title-text="'Restore original content?'"
            :content-text="`Restoring the original content will overwrite any changes you have made to the template.

            You will not be able to undo this action after you have saved the notification.

            Do you wish to continue?`"
            :cancel-button-text="'Cancel'"
            :submit-button-text="'Restore original content'"
            :prevent-close="true"
            @emit-submit="restoreEmail"
        />
        <pop-notify
            ref="notifydeleteemail"
            :class="'pop__notify--deleteemail'"
            :title-text="emailUsageIds.length ? 'Notification in use' : 'Delete notification?'"
            :cancel-button-text="emailUsageIds.length ? 'Close' : 'Cancel'"
            :content-text="''"
            :submit-button-active="!emailUsageIds.length"
            :submit-button-text="'Delete'"
            :submit-button-danger="!emailUsageIds.length"
            :submit-button-animate-loading="true"
            :submit-button-animate-loading-name="'delete-email'"
            :prevent-close="true"
            @emit-submit="deleteEmail"
        >
            <template v-if="emailUsageIds.length">
                To remove it, select a different notification for the courses where this template is in use. <br><br>
                <component-button
                    :name="'emails-list-table-check-usage-link'"
                    :text="true"
                    :to="{ name: 'ebs-course-list', query: { view: 'admin', ids: emailUsageIds } }"
                >Click here
                </component-button>
                to view the courses using this notification.
            </template>
            <template v-else>
                Deleting this notification will remove it from this workspace permanently. Do you wish to continue?
            </template>
        </pop-notify>
        <pop-notify
            ref="notifyupdateemailstatus"
            :class="'pop__notify--notifyupdateemailstatus'"
            :title-text="item.active ? 'Deactivate notification?' : 'Activate notification?'"
            :content-text="item.active ?
            `Deactivating this notification means learners will not receive this notification for those courses selected to use this notification.

            If you want this notification to be switched off for a specific course, you can do this through the course settings.`
            : `Reactivating this notification means learners will receive this notification for those courses selected to use this notification.

            If you want this notification to be switched off for a specific course, you can do this through the course settings.`"
            :cancel-button-text="'Cancel'"
            :submit-button-text="item.active ? 'Deactivate' : 'Activate'"
            :prevent-close="true"
            @emit-submit="updateEmailStatus"
        />
    </div>
</template>
<script>
import EmailsListTableItem from '@/components/ebs/emails/list/EmailsListTableItem'
import PopSideEmail from '@/components/default/shared/PopSideEmail'
import PopSide from '@/components/default/shared/PopSide'
import ComponentTable from '@/components/default/shared/ComponentTable'
import PopNotify from '@/components/default/shared/PopNotify'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'EmailsListTable',
  components: {
    ComponentButton,
    PopNotify,
    ComponentTable,
    PopSide,
    PopSideEmail
  },
  data () {
    return {
      item: '',
      emailUsageIds: [],
      EmailsListTableItem
    }
  },
  props: {
    items: {
      type: [Array, Object]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    valueId: {
      type: String
    }
  },
  computed: {
    emailGet () {
      return this.$store.getters.getEmail
    },
    title () {
      return this.$store.getters.getEmailName
    },
    emailId () {
      return this.$store.getters.getEmailId
    },
    emailOwnerId () {
      return this.$store.getters.getEmailOwnerId
    },
    emailUpdateSuccess () {
      return this.$store.getters.getEmailUpdateSuccess
    },
    emailStatus () {
      return this.$store.getters.getEmailStatus
    },
    emailCloned () {
      return this.$store.getters.getEmailCloned
    },
    emailIdentifier () {
      return this.$store.getters.getEmailIdentifier
    }
  },
  watch: {
    emailUpdateSuccess () {
      if (this.emailUpdateSuccess === true) {
        this.$refs.popnotification.closePop()
      }
    }
  },
  methods: {
    openNotifyRestoreEmail (data) {
      this.$refs.notifyrestoreemail.openNotify()
    },
    closeNotifyRestoreEmail (data) {
      if (this.$refs.notifyrestoreemail) {
        this.$refs.notifyrestoreemail.closeNotify()
      }
    },
    openNotifyDeleteEmail (data) {
      this.emailUsageIds = data.emailUsage && data.emailUsage.length ? data.emailUsage.join(',') : []
      this.$refs.notifydeleteemail.setStoreValue(data.id)
      this.$refs.notifydeleteemail.openNotify()
    },
    closeNotifyDeleteEmail (data) {
      if (this.$refs.notifydeleteemail) {
        this.$refs.notifydeleteemail.closeNotify()
      }
    },
    openNotificationEmail (data) {
      const value = data.item
      if (value) {
        this.setEmail(value)
      } else {
        this.getEmail(value)
      }
      this.$refs.popnotification.openPop()
    },
    closeNotificationEmail () {
      if (this.$refs.popnotification) {
        this.$refs.popnotification.closePop()
      }
    },
    openNotifyUpdateEmailStatus (data) {
      this.item = data
      this.$refs.notifyupdateemailstatus.openNotify()
    },
    closeNotifyUpdateEmailStatus (data) {
      if (this.$refs.notifyupdateemailstatus) {
        this.$refs.notifyupdateemailstatus.closeNotify()
      }
    },
    //
    setEmail (data) {
      this.$store.dispatch('setEmail', data)
    },
    getEmail (data) {
      this.$store.dispatch('getEmail', data)
    },
    clearEmail () {
      this.$store.dispatch('clearEmail')
    },
    resetEmail () {
      this.$store.dispatch('resetEmail')
      this.$refs.popnotificationemail.reset()
    },
    restoreEmail () {
      this.$store.dispatch('removeEmail').then(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Notification content restored',
          message: ``,
          status: 'success'
        })
      }).catch(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Notification content not restored',
          message: ``,
          status: 'error'
        })
      }).finally(() => {
        this.closeNotifyRestoreEmail()
        this.closeNotificationEmail()
        this.$eventBus.$emit('trigger-get-items')
      })
    },
    updateEmailStatus () {
      let data = JSON.parse(JSON.stringify(this.item))
      data.active = !data.active
      const ownerId = data.ownerId
      const dispatchName = ownerId ? 'updateEmail' : 'createEmail'
      this.$store.dispatch(dispatchName, data).then(() => {
        this.$eventBus.$emit('trigger-get-items')
      }).finally(() => {
        this.closeNotifyUpdateEmailStatus()
      })
    },
    deleteEmail () {
      const emailId = this.$refs.notifydeleteemail.storeValue
      if (emailId) {
        this.$store.dispatch('removeEmail', emailId).then(() => {
          this.$store.dispatch('defaultNotificationToastsAdd', {
            title: 'Notification deleted',
            message: ``,
            status: 'success'
          })
        }).catch(() => {
          this.$store.dispatch('defaultNotificationToastsAdd', {
            title: 'Notification not deleted',
            message: ``,
            status: 'error'
          })
        }).finally(() => {
          this.closeNotifyDeleteEmail()
          this.$eventBus.$emit('stop-delete-email')
          this.$eventBus.$emit('trigger-get-items')
        })
      } else {
        this.$eventBus.$emit('stop-delete-email')
      }
    },
    submitEmail (data) {
      const ownerId = this.emailOwnerId
      const dispatchName = ownerId ? 'updateEmail' : 'createEmail'
      this.$store.dispatch(dispatchName).finally(() => {
        this.closeNotificationEmail()
        this.$eventBus.$emit('stop-email-submit')
        this.$eventBus.$emit('trigger-get-items')
      })
    },
    handleSort (data) {
      this.$emit('emit-sort', data)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/emails/_emaillisttable.scss";
</style>
